import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEqual, isEmpty } from 'lodash';
import { Button } from 'react-bootstrap';

import { ProgressButton } from '@components';
import Actions, { thunks } from '@redux/app';
import { updateProgressButton } from '@config/utils';
import { withMsal } from '@azure/msal-react';
import config from '@config';
import utils from '@utils';
import FormField from './formField';
import { ADOPERATIONS, ROUTES } from '../../../utils/constants';

class ChangePassword extends Component {
	constructor(props) {
		super(props);

		this.state = {
			resetPasswordButtonState : '',
		};
	}

	shouldComponentUpdate = ({
		password,
		newPassword,
		confirmPassword,
		errors,
		buttonState,
	}) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.password, password)
			|| !isEqual(lastProps.newPassword, newPassword)
			|| !isEqual(lastProps.confirmPassword, confirmPassword)
			|| !isEqual(lastProps.errors, errors)
			|| !isEqual(lastProps.buttonState, buttonState)
		);
	}

	componentWillUnmount = () => {
		const { resetForm } = this.props;
		resetForm('changePassword');
	}

	handleOnChange = (property) => (e) => {
		const { setField } = this.props;
		setField('changePassword', property, e.target.value);
	}

	onCancel = () => {
		const { resetForm } = this.props;

		resetForm('changePassword');
	}

	onSave = (e) => {
		e.preventDefault();
		const { dispatch } = this.props;

		if (!this.validateForm()) {
			updateProgressButton({
				dispatch,
				module   : 'app',
				property : 'changePassword.buttonState',
				value    : 'error',
			});
			return;
		}

		dispatch(thunks.changePassword());
	}

	validateForm = () => {
		const {
			password,
			newPassword,
			confirmPassword,
			setErrors,
		} = this.props;
		const errors = {};

		if (isEmpty(password)) errors.password = true;
		if (isEmpty(newPassword)) errors.newPassword = true;
		if (isEmpty(confirmPassword)) errors.confirmPassword = true;
		else if (newPassword !== confirmPassword) {
			errors.newPassword = true;
			errors.confirmPassword = true;
		}

		setErrors('changePassword', errors);
		return isEmpty(errors);
	}

	updateProgressButton = (value, callback) => {
		utils.updateProgressButton({
			context  : this,
			property : 'resetPasswordButtonState',
			value,
			callback,
		});
	}

	handleADResetPassword = () => {
		const {
			Email,
			msalContext: { instance: msalInstance },
		} = this.props;

		this.updateProgressButton('loading');

		msalInstance.loginRedirect({
			loginHint            : Email,
			authority            : config.ENV_OPTIONS.adb2c.policies.resetPassword,
			scopes               : config.ENV_OPTIONS.adb2c.scopes,
			redirectUri          : ROUTES.ADCallback,
			state                : utils.encodeADState({ operation : ADOPERATIONS.changePassword }),
			extraQueryParameters : { uxConfig : utils.encodeADState({ disabledInputs : ['email'] }) },
		})
			.finally(() => this.updateProgressButton(''));
	}

	render() {
		const { resetPasswordButtonState } = this.state;

		const {
			password,
			newPassword,
			confirmPassword,
			errors,
			buttonState,
			setRef,
		} = this.props;

		const { adb2cEnabled } = window;

		return (
			<div
				className="card-section"
				ref={(ref) => setRef(ref)}
			>
				<h5 className="color-dark font-bold margin-bottom-20">Change Password</h5>
				<Choose>
					<When condition={adb2cEnabled}>
						<div className="flex-center flex-direction-column">
							<ProgressButton
								type="submit"
								className="btn btn-primary btn-medium btn-square"
								text="Change"
								onClick={this.handleADResetPassword}
								state={resetPasswordButtonState}
							/>
						</div>
					</When>
					<Otherwise>
						<FormField
							title="Old Password"
							isEdit
							type="password"
							name="password"
							value={password}
							placeholder="Enter old password"
							isError={errors.password}
							onChange={this.handleOnChange('password')}
							hasSeperator
						/>
						<FormField
							title="New Password"
							type="password"
							isEdit
							name="newPassword"
							value={newPassword}
							isError={errors.newPassword}
							onChange={this.handleOnChange('newPassword')}
							hasSeperator
						/>
						<FormField
							title="Confirm Password"
							type="password"
							isEdit
							name="confirmPassword"
							value={confirmPassword}
							isError={errors.confirmPassword}
							onChange={this.handleOnChange('confirmPassword')}
						/>
						<If condition={password || newPassword || confirmPassword}>
							<div className="width-all text-right margin-top-15">
								<Button
									bsStyle="link"
									className="margin-right-10"
									onClick={this.onCancel}
								>
									Cancel
								</Button>
								<ProgressButton
									type="submit"
									className="btn btn-primary height-42"
									text="Save"
									onClick={this.onSave}
									state={buttonState}
								/>
							</div>
						</If>
					</Otherwise>
				</Choose>

			</div>
		);
	}
}

const mapStateToProps = ({
	app : {
		user : { Email },
		changePassword : {
			password,
			newPassword,
			confirmPassword,
			errors,
			buttonState,
		},
	},
}) => ({
	password,
	newPassword,
	confirmPassword,
	errors,
	buttonState,
	Email,
});

const mapDispatchToProps = (dispatch) => ({
	dispatch,
	setField  : bindActionCreators(Actions, dispatch).setFormField,
	resetForm : bindActionCreators(Actions, dispatch).resetForm,
	setErrors : bindActionCreators(Actions, dispatch).setFormErrors,
});

ChangePassword.propTypes = {
	buttonState     : PropTypes.string,
	confirmPassword : PropTypes.string,
	dispatch        : PropTypes.func.isRequired,
	errors          : PropTypes.object.isRequired,
	newPassword     : PropTypes.string,
	password        : PropTypes.string,
	resetForm       : PropTypes.func.isRequired,
	setErrors       : PropTypes.func.isRequired,
	setField        : PropTypes.func.isRequired,
	setRef          : PropTypes.func.isRequired,
	msalContext     : PropTypes.object.isRequired,
	Email           : PropTypes.string.isRequired,
};

ChangePassword.defaultProps = {
	buttonState     : '',
	confirmPassword : '',
	newPassword     : '',
	password        : '',
};

export default withMsal(connect(mapStateToProps, mapDispatchToProps)(ChangePassword));
